<template>
  <div>
    <ActitiveTabcomponent :tabs="tabItems" :defaultTab="activeTab" @tab-changed="handleTabChange">
      <template v-slot:tab-buttons="{ activeTab }">
        <div class="flex items-center space-x-2">
          <!-- Stores tab buttons -->
          <template v-if="activeTab === 'Stores'">
            <div class="" :class="[$vuetify.breakpoint.lgAndUp ? 'flex' : 'flex-col']">
              <v-text-field
                v-model="filterStore"
                label="Store Name"
                solo
                flat
                clearable
                prepend-inner-icon="mdi-magnify"
                @input="handleStoreSearch"
                outlined
                dense
                hide-details
                class="filter-column"
              ></v-text-field>
            </div>

            <v-btn
              @click="handleStoreAction('add')"
              :color="$vuetify.theme.currentTheme.primary"
              class="white--text"
              v-show="canWrite"
            >
              <v-icon left dark>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>

          <!-- Partners tab buttons
          <template v-if="activeTab === 'Partners'">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-btn
                  :color="$vuetify.theme.currentTheme.primary"
                  class="white--text mr-4"
                  v-on="on"
                  v-show="canWrite"
                  @click="handlePartnerAction('bulk-create')"
                >
                  Bulk Create
                </v-btn>
              </template>
              <span>Bulk create new brands and products</span>
            </v-tooltip>
            <v-btn
              @click="handlePartnerAction('add')"
              :color="$vuetify.theme.currentTheme.primary"
              class="white--text"
              v-show="canWrite"
            >
              <v-icon left dark>mdi-plus</v-icon>
              Add
            </v-btn>
          </template> -->

          <!-- Products tab buttons -->
          <template v-if="activeTab === 'Products'">
            <v-text-field
              v-model="filterProduct"
              label="Product Name"
              solo
              flat
              clearable
              prepend-inner-icon="mdi-magnify"
              @input="handleProductSearch"
              outlined
              dense
              hide-details
              class="filter-column"
            ></v-text-field>
            <v-btn
              @click="handleProductAction('add')"
              :color="$vuetify.theme.currentTheme.primary"
              class="white--text"
              v-show="canWrite"
            >
              <v-icon left dark>mdi-plus</v-icon>
              Add
            </v-btn>
            <v-tooltip top>
              <template #activator="{ on }">
                <v-btn
                  :color="$vuetify.theme.currentTheme.primary"
                  class="white--text mr-4 normal-case"
                  v-on="on"
                  v-show="canWrite"
                  @click="handleProductAction('bulk-create')"
                >
                  <v-icon left small>mdi-upload</v-icon>
                  Bulk Create
                </v-btn>
              </template>
              <span>Bulk create new products and brands</span>
            </v-tooltip>
          </template>
        </div>
      </template>

      <!-- Tab Content Slots -->
      <template v-for="tab in visibleTabItems" v-slot:[tab.key]="">
        <div v-if="!isLoad">
          <v-main class="" style="padding: 0px">
            <component
              :is="tab.component"
              :ref="tab.key"
              :filterStore="activeTab === 'Stores' ? filterStore : undefined"
              :filterProduct="activeTab === 'Products' ? filterProduct : undefined"
              @show-add-store="showAddStoreDialog = true"
              @edit-store="handleEditStore"
              @show-add-product="showAddProductDialog = true"
              @edit-product="handleEditProduct"
            />
          </v-main>
        </div>
        <div v-else class="absolute w-full h-screen flex-col items-center flex justify-center">
          <v-progress-circular
            :color="$vuetify.theme.currentTheme.primary"
            indeterminate
            :size="50"
            :width="5"
          ></v-progress-circular>
          <div class="mt-2"><span>Please Wait...</span></div>
        </div>
      </template>
    </ActitiveTabcomponent>

    <!-- Add Store Dialog -->
    <v-dialog v-model="showAddStoreDialog" max-width="800px" persistent class="add-store-dialog">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center border-b border-gray-200">
          <h3 class="form-title">
            {{ editStoreData ? `Edit Store` : `Add Store` }}
          </h3>
          <v-btn icon @click="closeAddStoreDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <AddStorePartner
            @cancel="closeAddStoreDialog"
            :entityType="'Store'"
            :editStoreData="editStoreData"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Add Product Dialog -->
    <v-dialog
      v-model="showAddProductDialog"
      max-width="800px"
      persistent
      class="add-product-dialog"
    >
      <v-card>
        <!-- <v-card-title class="d-flex justify-space-between align-center border-b border-gray-200">
          <h3 class="form-title">
            {{ editProductData ? `Edit Product` : `Add Product` }}
          </h3>
          <v-btn icon @click="closeAddProductDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title> -->
        <v-card-text>
          <AddProduct @cancel="closeAddProductDialog" :editProductData="editProductData" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Stores from '~/components/Workforce/InventorySettings/Stores.vue'
import Partners from '~/components/Workforce/InventorySettings/Partners.vue'
import Products from '~/components/Workforce/InventorySettings/Products.vue'
import AddStorePartner from '~/components/Workforce/InventorySettings/AddStorePartner.vue'
import AddProduct from '~/components/Workforce/InventorySettings/AddProduct.vue'
import { isModuleFeatureAllowed, hasPermission } from '@/utils/common'
import permissionData from '@/utils/permissions'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'
import { active } from 'sortablejs'

export default {
  name: 'InventorySettings',
  layout: 'Workforce/default',
  components: {
    Stores,
    Partners,
    Products,
    ActitiveTabcomponent,
    AddStorePartner,
    AddProduct
  },
  data() {
    return {
      userData: this.$store.state.wfmPermissions,
      tabs: 0,
      isLoad: true,
      showAddStoreDialog: false,
      showAddProductDialog: false,
      editStoreData: null,
      editProductData: null,
      filterStore: '',
      filterProduct: ''
    }
  },
  computed: {
    canRead() {
      return hasPermission(this.userData, permissionData.inventoryRead)
    },
    canWrite() {
      return hasPermission(this.userData, permissionData.inventoryWrite)
    },
    tabItems() {
      return [
        {
          key: 'Stores',
          label: 'Stores',
          icon: 'mdi-store',
          component: 'Stores',
          visible: this.canRead && this.isFeatureVisible('MANAGE_STORES')
        },
        // {
        //   key: 'Partners',
        //   label: 'Brands',
        //   icon: 'mdi-bank',
        //   component: 'Partners',
        //   visible: this.canRead && this.isFeatureVisible('MANAGE_PARTNERS')
        // },
        {
          key: 'Products',
          label: 'Products',
          icon: 'mdi-package-variant',
          component: 'Products',
          visible: this.canRead && this.isFeatureVisible('MANAGE_PARTNER_PRODUCT_RELATION')
        }
      ]
    },
    visibleTabItems() {
      return this.tabItems.filter((tab) => tab.visible)
    },
    activeTab() {
      return this.$route.query.activeTab || this.defaultTabKey
    },
    defaultTabKey() {
      return this.visibleTabItems.length > 0 ? this.visibleTabItems[0].key : 'Stores'
    }
  },
  methods: {
    handleTabChange(tabKey) {
      if (this.$route.query.activeTab !== tabKey) {
        this.$router.replace({
          query: { ...this.$route.query, activeTab: tabKey }
        })
      }
    },

    handleStoreSearch(value) {
      // Update the filterStore value when search input changes
      this.filterStore = value
    },

    handleProductSearch(value) {
      // Update the filterProduct value when search input changes
      this.filterProduct = value
    },

    handleStoreAction(action) {
      if (action === 'add') {
        this.editStoreData = null
        this.showAddStoreDialog = true
      }
    },

    handleEditStore(item) {
      this.editStoreData = item
      this.showAddStoreDialog = true
    },

    closeAddStoreDialog() {
      this.showAddStoreDialog = false
      this.editStoreData = null
      // Refresh the stores list after adding/editing
      const storeComponent = this.$refs.Stores?.[0]
      if (storeComponent) {
        storeComponent.fetchStores()
      }
    },

    handleProductAction(action) {
      const productComponent = this.$refs.Products?.[0]
      if (productComponent) {
        if (action === 'add') {
          this.editProductData = null
          this.showAddProductDialog = true
        } else if (action === 'bulk-create') {
          productComponent.uploadBrands()
        }
      }
    },

    handleEditProduct(item) {
      this.editProductData = item
      this.showAddProductDialog = true
    },

    closeAddProductDialog() {
      this.showAddProductDialog = false
      this.editProductData = null
      // Refresh the products list after adding/editing
      const productComponent = this.$refs.Products?.[0]
      if (productComponent) {
        productComponent.fetchProducts()
      }
    },

    handlePartnerAction(action) {
      const partnerComponent = this.$refs.Partners?.[0]
      if (partnerComponent) {
        if (action === 'add') {
          partnerComponent.toggleshowAddPartner()
        } else if (action === 'bulk-create') {
          partnerComponent.uploadBrands()
        }
      }
    },

    isFeatureVisible(feature) {
      return isModuleFeatureAllowed('STOCK_MANAGEMENT', feature)
    }
  },
  mounted() {
    if (!this.$route.query.activeTab && this.defaultTabKey) {
      this.$router.replace({
        query: { ...this.$route.query, activeTab: this.defaultTabKey }
      })
    }

    // Remove loading state and detect initial tab buttons
    this.$nextTick(() => {
      this.isLoad = false
    })
  }
}
</script>

<style scoped>
.form-title {
  font-size: var(--font-heading);
  font-weight: var(--font-weight-semibold);
  padding: 0px;
  color: #21427d;
  margin: 0;
}

/* Dialog styling similar to AddOrder.vue */
.add-store-dialog .v-dialog__content,
.add-product-dialog .v-dialog__content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-store-dialog .v-dialog,
.add-product-dialog .v-dialog {
  border-radius: 0.5rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

/* Ensure the dialog content has proper padding and spacing */
.add-store-dialog .bg-white,
.add-product-dialog .bg-white {
  border-radius: 0.5rem;
}

.add-store-dialog .border-b,
.add-product-dialog .border-b {
  border-bottom: 1px solid #e2e8f0;
}

.add-store-dialog .p-4,
.add-product-dialog .p-4 {
  padding: 1rem;
}

.add-store-dialog .d-flex,
.add-product-dialog .d-flex {
  display: flex;
}

.add-store-dialog .justify-space-between,
.add-product-dialog .justify-space-between {
  justify-content: space-between;
}

.add-store-dialog .align-center,
.add-product-dialog .align-center {
  align-items: center;
}
.v-dialog > .v-card > .v-card__title {
  padding: 16px !important;
}
.v-dialog > .v-card > .v-card__text {
  padding: 0px !important;
}
.form-title {
  font-size: var(--font-heading);
  font-weight: var(--font-weight-semibold);
  padding: 0px;
  color: #21427d;
  margin: 0;
}
.v-dialog {
  overflow-y: hidden;
}
.filter-column {
  width: 300px;
}
</style>
